import moment from 'moment-timezone'
import React from 'react'
import { makeStyles } from '@material-ui/core'

import { useFeatureEnabled } from 'core/feature/hooks'
import { useUISettings } from 'hooks/useUISettings'
import { useHasRole } from 'civic-champs-shared/auth/hooks'
import { INTERNAL_SUPER_ADMIN } from 'civic-champs-shared/auth/utils/permissions'
import { useShowPrompt } from 'civic-champs-shared/core/modal/hooks'
import { EventListDifferencesPrompt } from './EventListDifferencesPrompt'

export interface EventListDifferencesProps {
  from: moment.MomentInput
  to: moment.MomentInput
}

const useStyles = makeStyles({
  root: {
    paddingTop: '10px',
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    display: 'inline',
    padding: 0,
    border: 0,
    font: 'inherit',
    textDecoration: 'underline',
    cursor: 'pointer',
    background: 'transparent',
    color: '#5C8DE8',
    WebkitAppearance: 'none',
  },
})

export const EventListDifferences = ({ from, to }: EventListDifferencesProps) => {
  // @ts-ignore
  const { showAdminItems } = useUISettings()
  const isInternalAdmin = useHasRole(INTERNAL_SUPER_ADMIN)
  const isEnabled = useFeatureEnabled('ClientSideEventProcessing')

  const classes = useStyles()

  const showPrompt = useShowPrompt(EventListDifferencesPrompt)
  const handleClick = () => {
    showPrompt({ from, to })
  }

  const isVisible = showAdminItems && isInternalAdmin && isEnabled

  return isVisible ? (
    <div className={classes.root}>
      <button className={classes.button} onClick={handleClick}>
        Compare Events
      </button>
    </div>
  ) : null
}
